import React, { useCallback, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, FormLabel, useRadioGroup } from '@chakra-ui/react';
import useResizeObserver from '@react-hook/resize-observer';
import { useFormikContext } from 'formik';

import { IChangeProject } from '../../../../redux/types';
import { RadioTab } from '../../../Controls/RadioTab/RadioTab';

import { homePageOptions } from './home-page-options';

import tabStyles from '../../../Controls/RadioTab/RadioTab.module.scss';
import styles from './DefaultHomePageTabs.module.scss';

const FIELD_NAME = 'user_default_home_page';
const TAB_WIDTH_NORMAL = parseInt(tabStyles.tabWidthNormal, 10);

export const DefaultHomePageTabs: React.FC = () => {
    const [wrapperNode, setWrapperNode] = useState<HTMLDivElement | null>(null);
    const [shrinkTabContent, setShrinkTabContent] = useState(false);
    const { t } = useTranslation('translations');
    const { setFieldValue, values } = useFormikContext<IChangeProject>();

    const { getRadioProps, getRootProps } = useRadioGroup({
        name: FIELD_NAME,
        value: values[FIELD_NAME],
        onChange(nextValue: string) {
            setFieldValue(FIELD_NAME, nextValue);
        },
    });

    const handleHideTabLabel = useCallback(() => {
        if (!wrapperNode) {
            return;
        }

        const availableLength = wrapperNode.offsetWidth;

        setShrinkTabContent(availableLength < TAB_WIDTH_NORMAL * homePageOptions.length);
    }, [wrapperNode]);

    useLayoutEffect(() => {
        handleHideTabLabel();
    }, [handleHideTabLabel]);

    useResizeObserver(wrapperNode, handleHideTabLabel);

    return (
        <FormControl
            {...getRootProps(undefined, (node: HTMLDivElement) => {
                setWrapperNode(node);
            })}
        >
            <FormLabel size="xs">{`${t('settings.default-tab')}:`}</FormLabel>
            <div className={styles.control}>
                {homePageOptions.map(({ value, label, icon: Icon }) => {
                    return (
                        <RadioTab {...getRadioProps({ value })} shrink={shrinkTabContent} icon={<Icon />} key={value}>
                            {label}
                        </RadioTab>
                    );
                })}
            </div>
        </FormControl>
    );
};
